var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasFields)?_c('div',{staticClass:"FormSectionFields"},_vm._l((_vm.sectionTemplateFields),function(ref){
var key = ref.key;
var label = ref.label;
return _c('Field',{key:key,attrs:{"label":label,"maxLength":60,"value":_vm.sectionFieldsProxy[key]},on:{"update:value":function($event){return _vm.setFieldValue(key, $event)}}})}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }